module.exports = __webpack_public_path__ + "static/media/own-the-stars.6731d44c.webp";